import getClientConfig from './getClientConfig';
import { DEBUG_LEVEL } from '../../../config/configConstants';

const debugLevel = getClientConfig().debugLevel || 0;
const consoleLog =
    (logLevel: number, logMethod: Function) =>
    (...values: any[]) => {
        if (debugLevel < logLevel) return;
        logMethod.apply(console, values);
    };

export default {
    debug: consoleLog(DEBUG_LEVEL.FINE, console.log), // eslint-disable-line no-console
    log: consoleLog(DEBUG_LEVEL.FINE, console.log), // eslint-disable-line no-console
    info: consoleLog(DEBUG_LEVEL.INFO, console.info), // eslint-disable-line no-console
    table: consoleLog(DEBUG_LEVEL.INFO, console.table), // eslint-disable-line no-console
    error: consoleLog(DEBUG_LEVEL.ERROR, console.error), // eslint-disable-line no-console
    warn: consoleLog(DEBUG_LEVEL.WARN, console.warn), // eslint-disable-line no-console
    groupCollapsed: consoleLog(DEBUG_LEVEL.OFF, console.groupCollapsed), // eslint-disable-line no-console
    group: consoleLog(DEBUG_LEVEL.OFF, console.group), // eslint-disable-line no-console
    groupEnd: consoleLog(DEBUG_LEVEL.OFF, console.groupEnd), // eslint-disable-line no-console
    debugGroupCollapsed: consoleLog(DEBUG_LEVEL.OFF, console.groupCollapsed), // eslint-disable-line no-console
    debugGroup: consoleLog(DEBUG_LEVEL.OFF, console.group), // eslint-disable-line no-console
    debugGroupEnd: consoleLog(DEBUG_LEVEL.OFF, console.groupEnd), // eslint-disable-line no-console
};
